import { createRouter, createWebHistory } from 'vue-router'
import { changePinRoutes } from './changePinRoutes'
import { droplinkRoutes } from './droplinkRoutes'
import { hublinkRoutes } from './hublinkRoutes'
import {
  nftReceiveSelectAddressRoute,
  receiveQrViewRoute,
  walletReceiveSelectAddressRoute,
  walletManageRoute,
  changeWalletLabelViewRoute,
  walletShowSettingRoute,
  settingViewRoute,
  walletAddAccountCoinListRoute,
  walletAddAccountInputLabelRoute,
  walletAddAccountCreateParentNetworkRoute,
  walletAddAccountSelectParentAccountRoute,
  walletAddAccountInputPinRoute,
  nftAddAccountCoinListRoute,
  nftAddAccountInputLabelRoute,
  nftAddAccountCreateParentNetworkRoute,
  nftAddAccountSelectParentAccountRoute,
  nftAddAccountInputPinRoute,
  transactionDetailRoutes,
  accountManageRoute,
  accountManageViewRoutes,
  deleteWalletRoutes,
  backupWalletRoutes,
  unlockWalletRoute,
  unlockWalletNFTRoute,
  unlockWalletAccountRoute,
  unlockWalletNFTDetailRoute,
} from './popup'
import { sendCoinRoutes } from './sendCoinRoutes'
import { sendNFTRoutes } from './sendNFTRoutes'
import { otpSettingRoutes, settingRoutes } from './settingRoutes'
import { addV2TestRoutes } from './v2TestRoutes'
import { useBackCountStore } from '@/stores'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...addV2TestRoutes(), // V2 테스트 라우트 추가
    {
      path: '/:catchAll(.*)',
      redirect: () => {
        // refreshToken이 있으면 dashboard로, 없으면 signin으로
        const refreshToken = localStorage.getItem('refreshToken')
        return refreshToken ? '/dashboard' : '/signin'
      },
    },
    {
      path: '/signin',
      name: 'signin',
      component: () => import('@/views/auth/SigninView.vue'),
    },
    {
      // 서비스 종료 안내 (로그인 불필요, 로그인 화면 배너에서 진입)
      path: '/notice',
      name: 'service_notice_public',
      component: () => import('@/views/notice/ServiceNoticeView.vue'),
    },
    {
      path: '/signin/email',
      name: 'signin_with_email',
      component: () => import('@/views/auth/user_email/SigninEmail.vue'),
    },
    {
      path: '/signin/password',
      name: 'signin_with_email_set_password',
      component: () => import('@/views/auth/user_email/SigninPassword.vue'),
    },
    {
      path: '/signin/oauth/before-oauth',
      name: 'before_oauth',
      component: () => import('@/views/auth/oauth/BeforeOAuth.vue'),
    },
    {
      path: '/signin/oauth/:provider/redirect',
      name: 'oauth_redirect',
      component: () => import('@/views/auth/oauth/RedirectHandler.vue'),
      props: true,
    },
    {
      path: '/signin/oauth_redirect',
      name: 'oauth_redirect',
      component: () => import('@/views/auth/oauth/OAuthRedirectHandler.vue'),
      props: true,
    },
    {
      path: '/signin/oauth/verify-email',
      name: 'signin_oauth_verify_email',
      component: () => import('@/views/auth/oauth/OAuthVerifyEmail.vue'),
    },
    {
      path: '/signup/complete/sdk',
      name: 'signup_complete_sdk',
      component: () =>
        import('@/views/auth/signup_complete/SignupCompleteSdk.vue'),
    },
    {
      path: '/reset/email',
      name: 'reset_with_email',
      component: () => import('@/views/auth/user_reset/ResetEmail.vue'),
    },
    {
      path: '/reset/password',
      name: 'reset_with_password',
      component: () => import('@/views/auth/user_reset/ResetPassword.vue'),
    },
    {
      path: '/reset/password/complete',
      name: 'reset_password_complete',
      component: () => import('@/views/auth/user_reset/ResetComplete.vue'),
    },
    {
      path: '/reset/email/authentication',
      name: 'reset_with_email_authentication',
      component: () => import('@/views/auth/user_reset/Authentication.vue'),
    },
    {
      path: '/signup/promotion',
      name: 'signup_promotion',
      component: () => import('@/views/auth/link_signup/LinkSignupView.vue'),
      children: [
        {
          path: 'login_select',
          name: 'link_signup_selecter',
          component: () =>
            import('@/views/auth/link_signup/LinkSignupSelector.vue'),
        },
        {
          path: 'login_email',
          name: 'link_signin_email',
          component: () =>
            import('@/views/auth/link_signup/LinkSigninEmail.vue'),
        },
        {
          path: 'authentication',
          name: 'link_signup_with_email_authentication',
          component: () =>
            import('@/views/auth/link_signup/LinkSignupAuth.vue'),
        },
        {
          path: 'set_password',
          name: 'link_signup_with_email_set_password',
          component: () =>
            import('@/views/auth/link_signup/LinkSignupSetPassword.vue'),
        },
        {
          path: 'set_pin',
          name: 'link_signup_with_email_set_pin',
          component: () =>
            import('@/views/auth/link_signup/LinkSignupSetPin.vue'),
        },
        {
          path: 'create_account',
          name: 'link_signup_create_account',
          component: () =>
            import('@/views/auth/link_signup/LinkSignupCreateAccount.vue'),
        },
      ],
    },
    {
      path: '/signup/email',
      name: 'signup_with_email',
      component: () => import('@/views/auth/signup/SignupView.vue'),
      redirect: '/signup/email/set_email',
      children: [
        {
          path: 'set_email',
          name: 'signup_with_email_set_email',
          component: () => import('@/views/auth/signup/SignupEmail.vue'),
        },
        {
          path: 'authentication',
          name: 'signup_with_email_authentication',
          component: () =>
            import('@/views/auth/signup/SignupAuthentication.vue'),
        },
        {
          path: 'set_password',
          name: 'signup_with_email_set_password',
          component: () => import('@/views/auth/signup/SignupPassword.vue'),
        },
      ],
    },
    {
      path: '/signup/set_pin',
      name: 'signup_with_email_set_pin',
      component: () => import('@/views/auth/signup/SignupPin.vue'),
    },
    {
      path: '/error/sign',
      name: 'sign_error',
      component: () => import('@/views/dashboard/error_page/error.vue'),
    },
    {
      path: '/error/502',
      name: 'error_502',
      component: () => import('@/views/dashboard/error_page/error502.vue'),
    },
    {
      path: '/error/423',
      name: 'error_423',
      component: () => import('@/views/dashboard/error_page/error423.vue'),
    },
    {
      path: '/coming_soon',
      name: 'coming_soon',
      component: () => import('@/views/ComingSoon.vue'),
    },
    {
      path: '/dashboard',
      component: () => import('@/views/dashboard/DashBoard.vue'),
      redirect: '/dashboard/detail/asset',
      children: [
        {
          path: 'detail',
          name: 'detail',
          redirect: '/dashboard/detail/asset',
          component: () => import('@/views/dashboard/DashBoardDetailView.vue'),
          children: [
            {
              path: 'nft',
              name: 'dashboard_detail_nft_tap',
              component: () =>
                import('@/views/dashboard/dashboard_detail/TabNft.vue'),
              props: false,
            },
            {
              path: 'asset',
              name: 'dashboard_detail_asset_tap',
              component: () =>
                import('@/views/dashboard/dashboard_detail/TabAsset.vue'),
              props: false,
              children: [
                walletShowSettingRoute('detail_asset'),
                ...settingViewRoute('detail_asset'),
              ],
            },
            {
              path: 'app/:appId?',
              name: 'dashboard_detail_app_tap',
              component: () =>
                import('@/views/dashboard/dashboard_detail/TabApp.vue'),
              props: true,
            },
          ],
        },
        {
          path: 'wallet',
          name: 'wallet',
          component: () => import('@/views/dashboard/WalletView.vue'),
          children: [
            {
              path: ':walletId',
              name: 'wallet_detail',
              component: () => import('@/views/dashboard/WalletDetailView.vue'),
              children: [
                walletReceiveSelectAddressRoute,
                receiveQrViewRoute(
                  'wallet_receive_account_qrview',
                  'receive/qrview/account',
                ),
                {
                  path: 'CreateWalletTypeSelect',
                  name: 'create_wallet_type_select',
                  component: () =>
                    import(
                      '@/views/dashboard/wallet_manage/recover-wallet/CreateWalletStarter.vue'
                    ),
                  props: false,
                },
                {
                  path: 'RecoverWallet/:label/:isDefault',
                  name: 'create_wallet_type_recover',
                  component: () =>
                    import(
                      '@/views/dashboard/wallet_manage/recover-wallet/RecoverWallet.vue'
                    ),
                  props: false,
                },
                {
                  path: 'RecoverWalletSetLabel',
                  name: 'recover_wallet_set_label',
                  component: () =>
                    import(
                      '@/views/dashboard/wallet_manage/recover-wallet/RecoverWalletLabelInput.vue'
                    ),
                  props: false,
                },
                {
                  path: 'RecoverWalletSetPin/:label/:isDefault',
                  name: 'recover_wallet_set_pin',
                  component: () =>
                    import(
                      '@/views/dashboard/wallet_manage/recover-wallet/RecoverWalletPinInput.vue'
                    ),
                  props: false,
                },
                {
                  path: 'RecoverWalletComplete/:label/:complete',
                  name: 'recover_wallet_complete',
                  component: () =>
                    import(
                      '@/views/dashboard/wallet_manage/recover-wallet/RecoverWalletComplete.vue'
                    ),
                  props: false,
                },
                // ...backupWalletRoutes,
                // ...deleteWalletRoutes,
                {
                  path: 'delete/deleteWalletStart',
                  name: 'delete_wallet_start',
                  component: () =>
                    import(
                      '@/views/dashboard/wallet_manage/delete-wallet/DeleteWalletStart.vue'
                    ),
                },
                unlockWalletRoute,
                walletManageRoute,
                changeWalletLabelViewRoute(
                  'change_wallet_label',
                  'manage/change/label',
                ),
                walletShowSettingRoute(),
                ...settingViewRoute(),
                walletAddAccountCoinListRoute,
                walletAddAccountInputLabelRoute,
                walletAddAccountCreateParentNetworkRoute,
                walletAddAccountSelectParentAccountRoute,
                walletAddAccountInputPinRoute({
                  name: 'wallet_account_pin',
                }),
              ],
            },
          ],
        },
        {
          path: 'account',
          name: 'accountDetail',
          component: () =>
            import('@/views/dashboard/account/AccountDetail.vue'),
          children: [
            accountManageRoute,
            ...accountManageViewRoutes(),
            ...transactionDetailRoutes,
            unlockWalletAccountRoute,
            receiveQrViewRoute('account_receive_account_qrview'),
          ],
          props: true,
        },
        {
          path: 'nft',
          name: 'nft',
          component: () => import('@/views/dashboard/NftView.vue'),
          children: [
            {
              path: ':walletId',
              name: 'nft_home',
              component: () =>
                import('@/views/dashboard/NftCollectionView.vue'),
              children: [
                nftReceiveSelectAddressRoute,
                receiveQrViewRoute('nft_receive_account_qrview'),
                nftAddAccountCoinListRoute,
                nftAddAccountInputLabelRoute,
                nftAddAccountCreateParentNetworkRoute,
                nftAddAccountSelectParentAccountRoute,
                nftAddAccountInputPinRoute({
                  name: 'nft_account_pin',
                }),
                unlockWalletNFTRoute,
              ],
              props: true,
            },
            {
              path: ':walletId/detail',
              name: 'nft_detail',
              component: () => import('@/views/dashboard/NftDetailView.vue'),
              children: [unlockWalletNFTDetailRoute],
              props: true,
            },
            {
              path: 'referral/dashboard',
              name: 'referral_dashboard',
              component: () =>
                import('@/views/hublink/PromotionReferralDashBoard.vue'),
              props: true,
            },
          ],
        },
        {
          path: 'my-project',
          name: 'my-project',
          component: () => import('@/views/ComingSoon.vue'),
        },
        {
          path: 'recommended-project',
          name: 'recommended-project',
          component: () => import('@/views/ComingSoon.vue'),
        },
        {
          path: 'wallet/backup_wallet',
          name: 'backup_wallet_container',
          component: () =>
            import(
              '@/views/dashboard/wallet_manage/backup-wallet/BackupWalletMain.vue'
            ),
          children: [...backupWalletRoutes],
        },
        {
          path: 'drops',
          name: 'drops',
          component: () => import('@/views/dashboard/drops/DropsView.vue'),
        },
        {
          path: 'campaign/:id',
          name: 'campaign_detail',
          component: () => import('@/views/droplink/CampaignDetailView.vue'),
          meta: {
            isDynamicTitle: true,
          },
        },
        {
          // 서비스 종료 안내 (delivery.wepin.io 안내 페이지를 콘텐츠 영역에 표시)
          path: 'notice',
          name: 'service_notice',
          component: () =>
            import('@/views/dashboard/notice/ServiceNoticeView.vue'),
          meta: {
            PageTitle: 'service_closure.title',
          },
        },
        ...deleteWalletRoutes,
        ...sendCoinRoutes,
        ...sendNFTRoutes,
        ...changePinRoutes,
        ...settingRoutes,
        ...otpSettingRoutes,
      ],
    },
    ...hublinkRoutes,
    ...droplinkRoutes,
  ],
})

// TODO: 모달, 팝업등 스크롤이 유지되어야 하는 컴포넌트가 추가될 시 해당 배열에 추가
// CAUTION: 반드시 정렬되어있어야함
const dontScroll = [
  'ChangeLayout',
  'EditList',
  'LockCautionAlert',
  'SortAccounts',
  'accountManage',
  'account_receive_account_qrview',
  'backup_confirm_caution',
  'backup_wallet_pin',
  'backup_wallet_sort_mnemonic',
  'backup_wallet_view_mnemonic',
  'change_wallet_label',
  'delete_wallet_start',
  'nft_receive_select_address',
  'showSetting',
  'detail_account_showSetting',
  'detail_account_ChangeLayout',
  'detail_account_EditList',
  'dashboard_detail_asset_tap',
  'dashboard_detail_nft_tap',
  'dashboard_detail_app_tap',
  'transaction_detail',
  'unlock_pin_account',
  'unlock_pin_nft',
  'unlock_pin_nft_detail',
  'unlock_pin_wallet',
  'wallet_add_account_coinlist',
  'wallet_manage',
  'wallet_receive_select_address',
]

router.beforeEach((to, from, next) => {
  // 스크롤 처리
  if (
    !dontScroll.includes(to.name ? to.name.toString() : '') &&
    !dontScroll.includes(from.name ? from.name.toString() : '')
  ) {
    window.scrollTo(0, 0)
  }

  // 백 카운트 처리
  if (
    to.name === 'wallet_send_coin_amount_set' ||
    to.name === 'account_send_coin_amount_set'
  ) {
    const backCountStore = useBackCountStore()
    backCountStore.addBackCount(-1)
  }

  // 로그인 체크: Public 경로가 아니고 dashboard로 가는 경우
  const publicPaths = [
    '/signin',
    '/signup',
    '/reset',
    '/error',
    '/coming_soon',
    '/droplink',
    '/hublink',
    '/v2-test',
  ]
  const isPublicPath = publicPaths.some((path) => to.path.startsWith(path))
  const isDashboardPath = to.path.startsWith('/dashboard')

  if (!isPublicPath && isDashboardPath) {
    // refreshToken 확인
    const refreshToken = localStorage.getItem('refreshToken')
    if (!refreshToken) {
      return next('/signin')
    }
  }

  next()
})

export default router
